// extracted by mini-css-extract-plugin
module.exports = {"audioSeekBar":"audio-progress-bar_audioSeekBar__2ZyM3","tick":"audio-progress-bar_tick__2j-Gk"};